<template>
  <div id="introduction_href" class="bg-2xl bg-lg bg-sm bg bg-center">
    <div class="max-w-7xl mx-auto pt-20 sm:pt-16 lg:pt-32 px-12 lg:px-10">
      <div class="grid grid-cols-1 lg:grid-cols-12 lg:gap-8">
        <div
          class="
            col-span-5
            banner-pic-1024 banner-pic-640
            mx-auto
            hidden
            sm:block
          "
        >
          <div class="flex content-center h-full">
            <img
              src="@/assets/banner-pic.png"
              class="object-scale-down test-pic"
              alt="banneer image"
            />
          </div>
        </div>
        <div class="col-span-7 lg:order-first">
          <div class="flex items-center justify-center lg:justify-start mt-7">
            <img
              src="@/assets/introduction-banner.svg"
              class="hidden sm:block"
              alt="banner introduction image"
            />
            <h1
              class="
                leading-relaxed
                text-3xl
                font-black
                ml-5
                mt-7
                sm:mt-0
                title-hidden
              "
            >
              農業部生物多樣性研究所<br class="sm:hidden" />植物標本館
            </h1>
            <h1 class="leading-relaxed text-3xl font-black ml-5 title-block">
              農業部生物多樣性研究所<br />保育中心<br />植物標本館
            </h1>
          </div>
          <p class="text-left text-lg mt-5 hidden lg:block">
            {{ content }}
            <span>...</span
            ><router-link to="/introduction"
              ><span class="underline">more</span></router-link
            >
          </p>
            <div class="leading-relaxed font-black text-2xl mt-6">
              <p class="text-left ml-5 lg:block hidden">標本搜尋</p>
            </div>
          <form @submit.prevent="searchAdvanced(false)">
            <div
              class="
                search-bar
                rounded-full
                w-full
                h-16
                mt-1
                py-2
                px-6
                flex
                space-x-3
              "
            >
              <input
                type="text"
                name="search_text"
                placeholder="學名/俗名搜尋"
                v-model="searchText"
              />
              <div class="hidden sm:block">
                <button
                  title="請輸入分類群學名 (不含命名者) 或中名關鍵字"
                  type="submit"
                  name="search_button"
                  class="
                    search-btn search-btn:hover
                    h-11
                    w-24
                    rounded-xl
                    flex
                    items-center
                    justify-center
                    space-x-2
                    flex-none
                  "
                >
                  <img
                    src="@/assets/illustrate.svg"
                    alt="搜尋提示"
                    class="w-5 h-5"
                  />
                  <p class="text-white font-black">搜尋</p>
                </button>
              </div>
              <button
                type="button"
                name="adavnced_search_button"
                class="
                  search-btn-more search-btn-more:hover
                  h-11
                  w-28
                  rounded-xl
                  text-white
                  font-black
                  flex-none
                  hidden
                  sm:block
                "
                @click="searchAdvanced(true)"
              >
                進階搜尋
              </button>
            </div>
            <div class="mt-5 sm:hidden">
              <div class="flex space-x-2 justify-center">
                <button
                  title="請輸入分類群學名 (不含命名者) 或中名關鍵字"
                  type="submit"
                  name="sm_search_button"
                  class="
                    search-btn search-btn:hover
                    h-11
                    w-24
                    rounded-xl
                    flex
                    items-center
                    justify-center
                    space-x-2
                    flex-none
                  "
                >
                  <p class="text-white font-black">搜尋</p>
                  <img
                    src="@/assets/illustrate.svg"
                    alt="搜尋提示"
                    class="w-5 h-5"
                  />
                </button>
                <button
                  type="button"
                  name="sm_advanced_search_button"
                  class="
                    search-btn-more search-btn-more:hover
                    h-11
                    w-28
                    rounded-xl
                    text-white
                    font-black
                    flex-none
                  "
                  @click="searchAdvanced(true)"
                >
                  進階搜尋
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIntroduction } from '@/api/introductions'

export default {
  name: "Introduction",
  data() {
    return {
      content: "",
      searchText: "",
    };
  },

  mounted() {
    getIntroduction(300).then(
      (response) => {
        this.content = response.data.content_text;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },

  methods: {
    searchAdvanced(isAdvanced) {
      if (isAdvanced === false && this.searchText === "") {
        this.$toast.info("請輸入搜尋條件！", { queue: true, duration: 1000 });
      } else {
        this.$store.commit(
          "search/setFields",
          isAdvanced ? {} : { simple_search_name: this.searchText }
        );
        this.$store.commit("search/resetVertexes");
        this.$store.commit("search/resetSpecimenMarkers");
        this.$store.commit("search/setPageNumber", 1);

        if (isAdvanced) {
          this.$router.push("/search-advanced");
        } else {
          this.$router.push("/search");
        }
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 1536px) {
  .bg-2xl {
    width: 100%;
    height: 600px;
    background-image: url("../../assets/bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .bg-lg {
    width: 100%;
    height: 600px;
    background-image: url("../../assets/bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .bg-sm {
    width: 100%;
    height: 600px;
    background-image: url("../../assets/bg-over640.jpg");
  }

  .banner-pic-1024 {
    width: 300px;
  }
}

@media (max-width: 639.98px) {
  .bg {
    width: 100%;
    height: 500px;
    background-image: url("../../assets/bg-under640.jpg");
  }

  .banner-pic-640 {
    width: 160px;
  }
}

@media (min-width: 420px) {
  .title-block {
    display: none;
  }
}

@media (max-width: 419.98px) {
  .title-hidden {
    display: none;
  }
}

.search-bar {
  background-color: #64859d;
}

input[type="text"] {
  width: 100%;
  border-radius: 10px;
  font-size: 16px;
  background-color: white;
  background-image: url("../../assets/search.svg");
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}

.search-btn {
  background-color: #c9a798;
}

.search-btn:hover {
  background-color: #a8897c;
}

.search-btn-more {
  background-color: #405d73;
}

.search-btn-more:hover {
  background-color: #263a49;
}

a:hover {
  text-decoration: underline;
  color: #64859d;
}
</style>
